import "./theme-context.css.ts.vanilla.css-mistica.js";
var r = {
    cardTitle: {
        weight: "var(--pa0wjc8m)"
    },
    button: {
        weight: "var(--pa0wjc8n)"
    },
    link: {
        weight: "var(--pa0wjc8o)"
    },
    title1: {
        weight: "var(--pa0wjc8p)"
    },
    title2: {
        weight: "var(--pa0wjc8q)"
    },
    title3: {
        weight: "var(--pa0wjc8r)",
        size: "var(--pa0wjc8s)",
        lineHeight: "var(--pa0wjc8t)"
    },
    indicator: {
        weight: "var(--pa0wjc8u)"
    },
    tabsLabel: {
        weight: "var(--pa0wjc8v)",
        size: "var(--pa0wjc8w)",
        lineHeight: "var(--pa0wjc8x)"
    },
    navigationBar: {
        weight: "var(--pa0wjc8y)"
    },
    text1: {
        size: "var(--pa0wjc8z)",
        lineHeight: "var(--pa0wjc90)"
    },
    text2: {
        size: "var(--pa0wjc91)",
        lineHeight: "var(--pa0wjc92)"
    },
    text3: {
        size: "var(--pa0wjc93)",
        lineHeight: "var(--pa0wjc94)"
    },
    text4: {
        size: "var(--pa0wjc95)",
        lineHeight: "var(--pa0wjc96)"
    },
    text5: {
        weight: "var(--pa0wjc97)",
        size: "var(--pa0wjc98)",
        lineHeight: "var(--pa0wjc99)"
    },
    text6: {
        weight: "var(--pa0wjc9a)",
        size: "var(--pa0wjc9b)",
        lineHeight: "var(--pa0wjc9c)"
    },
    text7: {
        weight: "var(--pa0wjc9d)",
        size: "var(--pa0wjc9e)",
        lineHeight: "var(--pa0wjc9f)"
    },
    text8: {
        weight: "var(--pa0wjc9g)",
        size: "var(--pa0wjc9h)",
        lineHeight: "var(--pa0wjc9i)"
    },
    text9: {
        weight: "var(--pa0wjc9j)",
        size: "var(--pa0wjc9k)",
        lineHeight: "var(--pa0wjc9l)"
    },
    text10: {
        weight: "var(--pa0wjc9m)",
        size: "var(--pa0wjc9n)",
        lineHeight: "var(--pa0wjc9o)"
    }
}, e = "pa0wjc9p", c = {
    colors: {
        appBarBackground: "var(--pa0wjc0)",
        background: "var(--pa0wjc1)",
        backgroundContainer: "var(--pa0wjc2)",
        backgroundContainerError: "var(--pa0wjc3)",
        backgroundContainerHover: "var(--pa0wjc4)",
        backgroundContainerPressed: "var(--pa0wjc5)",
        backgroundContainerBrand: "var(--pa0wjc6)",
        backgroundContainerBrandHover: "var(--pa0wjc7)",
        backgroundContainerBrandPressed: "var(--pa0wjc8)",
        backgroundContainerBrandOverInverse: "var(--pa0wjc9)",
        backgroundContainerAlternative: "var(--pa0wjca)",
        backgroundBrand: "var(--pa0wjcb)",
        backgroundBrandSecondary: "var(--pa0wjcc)",
        backgroundOverlay: "var(--pa0wjcd)",
        backgroundSkeleton: "var(--pa0wjce)",
        backgroundSkeletonInverse: "var(--pa0wjcf)",
        backgroundAlternative: "var(--pa0wjcg)",
        backgroundBrandTop: "var(--pa0wjch)",
        backgroundBrandBottom: "var(--pa0wjci)",
        navigationBarBackground: "var(--pa0wjcj)",
        skeletonWave: "var(--pa0wjck)",
        border: "var(--pa0wjcl)",
        borderLow: "var(--pa0wjcm)",
        borderHigh: "var(--pa0wjcn)",
        borderSelected: "var(--pa0wjco)",
        buttonDangerBackground: "var(--pa0wjcp)",
        buttonDangerBackgroundPressed: "var(--pa0wjcq)",
        buttonDangerBackgroundHover: "var(--pa0wjcr)",
        buttonLinkDangerBackgroundPressed: "var(--pa0wjcs)",
        buttonLinkDangerBackgroundInverse: "var(--pa0wjct)",
        buttonLinkDangerBackgroundInversePressed: "var(--pa0wjcu)",
        buttonLinkBackgroundPressed: "var(--pa0wjcv)",
        buttonLinkBackgroundInversePressed: "var(--pa0wjcw)",
        buttonPrimaryBackground: "var(--pa0wjcx)",
        buttonPrimaryBackgroundInverse: "var(--pa0wjcy)",
        buttonPrimaryBackgroundPressed: "var(--pa0wjcz)",
        buttonPrimaryBackgroundInversePressed: "var(--pa0wjc10)",
        buttonPrimaryBackgroundHover: "var(--pa0wjc11)",
        buttonSecondaryBorder: "var(--pa0wjc12)",
        buttonSecondaryBorderPressed: "var(--pa0wjc13)",
        buttonSecondaryBorderInverse: "var(--pa0wjc14)",
        buttonSecondaryBorderInversePressed: "var(--pa0wjc15)",
        buttonSecondaryBackgroundHover: "var(--pa0wjc16)",
        buttonSecondaryBackgroundPressed: "var(--pa0wjc17)",
        buttonSecondaryBackgroundInverseHover: "var(--pa0wjc18)",
        buttonSecondaryBackgroundInversePressed: "var(--pa0wjc19)",
        control: "var(--pa0wjc1a)",
        controlActivated: "var(--pa0wjc1b)",
        controlInverse: "var(--pa0wjc1c)",
        controlActivatedInverse: "var(--pa0wjc1d)",
        controlError: "var(--pa0wjc1e)",
        barTrack: "var(--pa0wjc1f)",
        loadingBar: "var(--pa0wjc1g)",
        loadingBarBackground: "var(--pa0wjc1h)",
        textActivated: "var(--pa0wjc1i)",
        toggleAndroidInactive: "var(--pa0wjc1j)",
        toggleAndroidBackgroundActive: "var(--pa0wjc1k)",
        iosControlKnob: "var(--pa0wjc1l)",
        divider: "var(--pa0wjc1m)",
        dividerInverse: "var(--pa0wjc1n)",
        navigationBarDivider: "var(--pa0wjc1o)",
        badge: "var(--pa0wjc1p)",
        feedbackErrorBackground: "var(--pa0wjc1q)",
        feedbackInfoBackground: "var(--pa0wjc1r)",
        brand: "var(--pa0wjc1s)",
        brandHigh: "var(--pa0wjc1t)",
        inverse: "var(--pa0wjc1u)",
        neutralHigh: "var(--pa0wjc1v)",
        neutralLow: "var(--pa0wjc1w)",
        neutralLowAlternative: "var(--pa0wjc1x)",
        neutralMedium: "var(--pa0wjc1y)",
        neutralMediumInverse: "var(--pa0wjc1z)",
        promo: "var(--pa0wjc20)",
        textBrand: "var(--pa0wjc21)",
        error: "var(--pa0wjc22)",
        highlight: "var(--pa0wjc23)",
        success: "var(--pa0wjc24)",
        warning: "var(--pa0wjc25)",
        textPrimary: "var(--pa0wjc26)",
        textPrimaryInverse: "var(--pa0wjc27)",
        textSecondary: "var(--pa0wjc28)",
        textSecondaryInverse: "var(--pa0wjc29)",
        textError: "var(--pa0wjc2a)",
        textErrorInverse: "var(--pa0wjc2b)",
        textButtonPrimary: "var(--pa0wjc2c)",
        textButtonPrimaryInverse: "var(--pa0wjc2d)",
        textButtonPrimaryInversePressed: "var(--pa0wjc2e)",
        textButtonSecondary: "var(--pa0wjc2f)",
        textButtonSecondaryPressed: "var(--pa0wjc2g)",
        textButtonSecondaryInverse: "var(--pa0wjc2h)",
        textButtonSecondaryInversePressed: "var(--pa0wjc2i)",
        textLink: "var(--pa0wjc2j)",
        textLinkInverse: "var(--pa0wjc2k)",
        textLinkDanger: "var(--pa0wjc2l)",
        textLinkSnackbar: "var(--pa0wjc2m)",
        textNavigationBarPrimary: "var(--pa0wjc2n)",
        textNavigationBarSecondary: "var(--pa0wjc2o)",
        textNavigationSearchBarHint: "var(--pa0wjc2p)",
        textNavigationSearchBarText: "var(--pa0wjc2q)",
        textAppBar: "var(--pa0wjc2r)",
        textAppBarSelected: "var(--pa0wjc2s)",
        successLow: "var(--pa0wjc2t)",
        warningLow: "var(--pa0wjc2u)",
        errorLow: "var(--pa0wjc2v)",
        promoLow: "var(--pa0wjc2w)",
        brandLow: "var(--pa0wjc2x)",
        successHigh: "var(--pa0wjc2y)",
        warningHigh: "var(--pa0wjc2z)",
        errorHigh: "var(--pa0wjc30)",
        promoHigh: "var(--pa0wjc31)",
        successHighInverse: "var(--pa0wjc32)",
        warningHighInverse: "var(--pa0wjc33)",
        errorHighInverse: "var(--pa0wjc34)",
        promoHighInverse: "var(--pa0wjc35)",
        tagTextPromo: "var(--pa0wjc36)",
        tagTextActive: "var(--pa0wjc37)",
        tagTextInactive: "var(--pa0wjc38)",
        tagTextSuccess: "var(--pa0wjc39)",
        tagTextWarning: "var(--pa0wjc3a)",
        tagTextError: "var(--pa0wjc3b)",
        tagBackgroundPromo: "var(--pa0wjc3c)",
        tagBackgroundActive: "var(--pa0wjc3d)",
        tagBackgroundInactive: "var(--pa0wjc3e)",
        tagBackgroundSuccess: "var(--pa0wjc3f)",
        tagBackgroundWarning: "var(--pa0wjc3g)",
        tagBackgroundError: "var(--pa0wjc3h)",
        customTabsBackground: "var(--pa0wjc3i)",
        coverBackgroundHover: "var(--pa0wjc3j)",
        coverBackgroundPressed: "var(--pa0wjc3k)",
        cardContentOverlay: "var(--pa0wjc3l)"
    },
    rawColors: {
        appBarBackground: "var(--pa0wjc3m)",
        background: "var(--pa0wjc3n)",
        backgroundContainer: "var(--pa0wjc3o)",
        backgroundContainerError: "var(--pa0wjc3p)",
        backgroundContainerHover: "var(--pa0wjc3q)",
        backgroundContainerPressed: "var(--pa0wjc3r)",
        backgroundContainerBrand: "var(--pa0wjc3s)",
        backgroundContainerBrandHover: "var(--pa0wjc3t)",
        backgroundContainerBrandPressed: "var(--pa0wjc3u)",
        backgroundContainerBrandOverInverse: "var(--pa0wjc3v)",
        backgroundContainerAlternative: "var(--pa0wjc3w)",
        backgroundBrand: "var(--pa0wjc3x)",
        backgroundBrandSecondary: "var(--pa0wjc3y)",
        backgroundOverlay: "var(--pa0wjc3z)",
        backgroundSkeleton: "var(--pa0wjc40)",
        backgroundSkeletonInverse: "var(--pa0wjc41)",
        backgroundAlternative: "var(--pa0wjc42)",
        backgroundBrandTop: "var(--pa0wjc43)",
        backgroundBrandBottom: "var(--pa0wjc44)",
        navigationBarBackground: "var(--pa0wjc45)",
        skeletonWave: "var(--pa0wjc46)",
        border: "var(--pa0wjc47)",
        borderLow: "var(--pa0wjc48)",
        borderHigh: "var(--pa0wjc49)",
        borderSelected: "var(--pa0wjc4a)",
        buttonDangerBackground: "var(--pa0wjc4b)",
        buttonDangerBackgroundPressed: "var(--pa0wjc4c)",
        buttonDangerBackgroundHover: "var(--pa0wjc4d)",
        buttonLinkDangerBackgroundPressed: "var(--pa0wjc4e)",
        buttonLinkDangerBackgroundInverse: "var(--pa0wjc4f)",
        buttonLinkDangerBackgroundInversePressed: "var(--pa0wjc4g)",
        buttonLinkBackgroundPressed: "var(--pa0wjc4h)",
        buttonLinkBackgroundInversePressed: "var(--pa0wjc4i)",
        buttonPrimaryBackground: "var(--pa0wjc4j)",
        buttonPrimaryBackgroundInverse: "var(--pa0wjc4k)",
        buttonPrimaryBackgroundPressed: "var(--pa0wjc4l)",
        buttonPrimaryBackgroundInversePressed: "var(--pa0wjc4m)",
        buttonPrimaryBackgroundHover: "var(--pa0wjc4n)",
        buttonSecondaryBorder: "var(--pa0wjc4o)",
        buttonSecondaryBorderPressed: "var(--pa0wjc4p)",
        buttonSecondaryBorderInverse: "var(--pa0wjc4q)",
        buttonSecondaryBorderInversePressed: "var(--pa0wjc4r)",
        buttonSecondaryBackgroundHover: "var(--pa0wjc4s)",
        buttonSecondaryBackgroundPressed: "var(--pa0wjc4t)",
        buttonSecondaryBackgroundInverseHover: "var(--pa0wjc4u)",
        buttonSecondaryBackgroundInversePressed: "var(--pa0wjc4v)",
        control: "var(--pa0wjc4w)",
        controlActivated: "var(--pa0wjc4x)",
        controlInverse: "var(--pa0wjc4y)",
        controlActivatedInverse: "var(--pa0wjc4z)",
        controlError: "var(--pa0wjc50)",
        barTrack: "var(--pa0wjc51)",
        loadingBar: "var(--pa0wjc52)",
        loadingBarBackground: "var(--pa0wjc53)",
        textActivated: "var(--pa0wjc54)",
        toggleAndroidInactive: "var(--pa0wjc55)",
        toggleAndroidBackgroundActive: "var(--pa0wjc56)",
        iosControlKnob: "var(--pa0wjc57)",
        divider: "var(--pa0wjc58)",
        dividerInverse: "var(--pa0wjc59)",
        navigationBarDivider: "var(--pa0wjc5a)",
        badge: "var(--pa0wjc5b)",
        feedbackErrorBackground: "var(--pa0wjc5c)",
        feedbackInfoBackground: "var(--pa0wjc5d)",
        brand: "var(--pa0wjc5e)",
        brandHigh: "var(--pa0wjc5f)",
        inverse: "var(--pa0wjc5g)",
        neutralHigh: "var(--pa0wjc5h)",
        neutralLow: "var(--pa0wjc5i)",
        neutralLowAlternative: "var(--pa0wjc5j)",
        neutralMedium: "var(--pa0wjc5k)",
        neutralMediumInverse: "var(--pa0wjc5l)",
        promo: "var(--pa0wjc5m)",
        textBrand: "var(--pa0wjc5n)",
        error: "var(--pa0wjc5o)",
        highlight: "var(--pa0wjc5p)",
        success: "var(--pa0wjc5q)",
        warning: "var(--pa0wjc5r)",
        textPrimary: "var(--pa0wjc5s)",
        textPrimaryInverse: "var(--pa0wjc5t)",
        textSecondary: "var(--pa0wjc5u)",
        textSecondaryInverse: "var(--pa0wjc5v)",
        textError: "var(--pa0wjc5w)",
        textErrorInverse: "var(--pa0wjc5x)",
        textButtonPrimary: "var(--pa0wjc5y)",
        textButtonPrimaryInverse: "var(--pa0wjc5z)",
        textButtonPrimaryInversePressed: "var(--pa0wjc60)",
        textButtonSecondary: "var(--pa0wjc61)",
        textButtonSecondaryPressed: "var(--pa0wjc62)",
        textButtonSecondaryInverse: "var(--pa0wjc63)",
        textButtonSecondaryInversePressed: "var(--pa0wjc64)",
        textLink: "var(--pa0wjc65)",
        textLinkInverse: "var(--pa0wjc66)",
        textLinkDanger: "var(--pa0wjc67)",
        textLinkSnackbar: "var(--pa0wjc68)",
        textNavigationBarPrimary: "var(--pa0wjc69)",
        textNavigationBarSecondary: "var(--pa0wjc6a)",
        textNavigationSearchBarHint: "var(--pa0wjc6b)",
        textNavigationSearchBarText: "var(--pa0wjc6c)",
        textAppBar: "var(--pa0wjc6d)",
        textAppBarSelected: "var(--pa0wjc6e)",
        successLow: "var(--pa0wjc6f)",
        warningLow: "var(--pa0wjc6g)",
        errorLow: "var(--pa0wjc6h)",
        promoLow: "var(--pa0wjc6i)",
        brandLow: "var(--pa0wjc6j)",
        successHigh: "var(--pa0wjc6k)",
        warningHigh: "var(--pa0wjc6l)",
        errorHigh: "var(--pa0wjc6m)",
        promoHigh: "var(--pa0wjc6n)",
        successHighInverse: "var(--pa0wjc6o)",
        warningHighInverse: "var(--pa0wjc6p)",
        errorHighInverse: "var(--pa0wjc6q)",
        promoHighInverse: "var(--pa0wjc6r)",
        tagTextPromo: "var(--pa0wjc6s)",
        tagTextActive: "var(--pa0wjc6t)",
        tagTextInactive: "var(--pa0wjc6u)",
        tagTextSuccess: "var(--pa0wjc6v)",
        tagTextWarning: "var(--pa0wjc6w)",
        tagTextError: "var(--pa0wjc6x)",
        tagBackgroundPromo: "var(--pa0wjc6y)",
        tagBackgroundActive: "var(--pa0wjc6z)",
        tagBackgroundInactive: "var(--pa0wjc70)",
        tagBackgroundSuccess: "var(--pa0wjc71)",
        tagBackgroundWarning: "var(--pa0wjc72)",
        tagBackgroundError: "var(--pa0wjc73)",
        customTabsBackground: "var(--pa0wjc74)",
        coverBackgroundHover: "var(--pa0wjc75)",
        coverBackgroundPressed: "var(--pa0wjc76)",
        cardContentOverlay: "var(--pa0wjc77)"
    },
    borderRadii: {
        button: "var(--pa0wjc78)",
        input: "var(--pa0wjc79)",
        container: "var(--pa0wjc7a)",
        legacyDisplay: "var(--pa0wjc7b)",
        popup: "var(--pa0wjc7c)",
        checkbox: "var(--pa0wjc7d)",
        indicator: "var(--pa0wjc7e)",
        sheet: "var(--pa0wjc7f)",
        bar: "var(--pa0wjc7g)",
        avatar: "var(--pa0wjc7h)",
        mediaSmall: "var(--pa0wjc7i)"
    },
    textPresets: {
        cardTitle: {
            weight: "var(--pa0wjc7j)"
        },
        button: {
            weight: "var(--pa0wjc7k)"
        },
        link: {
            weight: "var(--pa0wjc7l)"
        },
        title1: {
            weight: "var(--pa0wjc7m)"
        },
        title2: {
            weight: "var(--pa0wjc7n)"
        },
        title3: {
            weight: "var(--pa0wjc7o)",
            size: "var(--pa0wjc7p)",
            lineHeight: "var(--pa0wjc7q)"
        },
        indicator: {
            weight: "var(--pa0wjc7r)"
        },
        tabsLabel: {
            weight: "var(--pa0wjc7s)",
            size: "var(--pa0wjc7t)",
            lineHeight: "var(--pa0wjc7u)"
        },
        navigationBar: {
            weight: "var(--pa0wjc7v)"
        },
        text1: {
            size: "var(--pa0wjc7w)",
            lineHeight: "var(--pa0wjc7x)"
        },
        text2: {
            size: "var(--pa0wjc7y)",
            lineHeight: "var(--pa0wjc7z)"
        },
        text3: {
            size: "var(--pa0wjc80)",
            lineHeight: "var(--pa0wjc81)"
        },
        text4: {
            size: "var(--pa0wjc82)",
            lineHeight: "var(--pa0wjc83)"
        },
        text5: {
            weight: "var(--pa0wjc84)",
            size: "var(--pa0wjc85)",
            lineHeight: "var(--pa0wjc86)"
        },
        text6: {
            weight: "var(--pa0wjc87)",
            size: "var(--pa0wjc88)",
            lineHeight: "var(--pa0wjc89)"
        },
        text7: {
            weight: "var(--pa0wjc8a)",
            size: "var(--pa0wjc8b)",
            lineHeight: "var(--pa0wjc8c)"
        },
        text8: {
            weight: "var(--pa0wjc8d)",
            size: "var(--pa0wjc8e)",
            lineHeight: "var(--pa0wjc8f)"
        },
        text9: {
            weight: "var(--pa0wjc8g)",
            size: "var(--pa0wjc8h)",
            lineHeight: "var(--pa0wjc8i)"
        },
        text10: {
            weight: "var(--pa0wjc8j)",
            size: "var(--pa0wjc8k)",
            lineHeight: "var(--pa0wjc8l)"
        }
    }
};
export { r as textPresetResponsiveVarsContract, e as themeVars, c as themeVarsContract };
